/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL, RangePreset } from 'cio/utils/date-picker';
import { TimeRange } from 'cio/utils/time';
import { action } from '@ember/object';

export interface CioExportModalArgs {
  onClose: () => unknown;
  onExport: () => Promise<unknown>;
  canClear: boolean;
  onRangeSelect: (timeRange: TimeRange | null, setExportTime: boolean) => unknown;
  buttonText?: string;
  exportModalMessage?: string;
  unsetExportCSVModalTimestamps?: boolean;
  maxRange?: string;
  dateRangePresets?: RangePreset[];
}

export default class CioDeliveriesExportModal extends Component<CioExportModalArgs> {
  @tracked timeRange: TimeRange | null =
    this.args.unsetExportCSVModalTimestamps === true ? null : LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL.getRange();

  constructor(owner: unknown, args: CioExportModalArgs) {
    super(owner, args);

    this.args.onRangeSelect(this.timeRange, true);
  }

  get maxRange() {
    return this.args.maxRange ?? '6 months';
  }

  @action
  onRangeSelect(timeRange: TimeRange | null) {
    this.timeRange = timeRange;

    this.args.onRangeSelect(timeRange, true);
  }
}

// TODO: Maybe if showExportCSVModal is true, send timerange with onExport if onRangeSelect is not defined
// TODO deal with modal on modal
